import { CreateOrderResponse, Product } from 'src/api/@generated/backend';

import { selectProductsOrThrow } from 'src/state/request/selectors';
import { RootState } from 'src/state/types';
import { getOrThrow } from 'src/utils/type-utils';

import { OrderStates } from './types';

export const selectOrderFailed = (state: RootState): boolean => state.order.state === OrderStates.ABORT;

export const orderStartedOrFailed = (state: RootState): boolean =>
  [OrderStates.START, OrderStates.ABORT].includes(state.order.state);

export const selectHasOrderBeenConfirmed = (state: RootState): boolean => state.order.state === OrderStates.DONE;

export const selectHasOrderProcessStarted = (state: RootState): boolean => state.order.state === OrderStates.START;

export const selectHasOrderProcessStartedOrCompleted = (state: RootState): boolean =>
  state.order.state === OrderStates.START || state.order.state === OrderStates.DONE;

export const selectOrderConfirmation = (state: RootState): CreateOrderResponse | undefined => state.order.confirmation;

export const selectProductIndex =
  (selectedProduct: Product) =>
  (state: RootState): number =>
    selectProductsOrThrow(state)
      .map((product) => product.key)
      .indexOf(selectedProduct.key);

export const selectSelectedProductOrThrow = (state: RootState): Product =>
  getOrThrow(selectSelectedProduct(state), 'Invalid state. Product must be selected');

export const selectSelectedProduct = (state: RootState): Product | undefined => state.order.selectedProduct;
